import { DisturbanceInfoText } from '@config/DisturbanceConfig';
import { ALLOWED_LANGUAGES, Language } from '@stores/LanguageStore';

export const parseTextParams = (textValue: string, paramObject: any) => {
  return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
};

export const postCategory = (path: string) => {
  if (!path) {
    return '';
  }
  if (path.includes('/era')) {
    return 'eraklient';
  } else if (path.includes('/ari')) {
    return 'ariklient';
  } else if (path.includes('/ettevottest')) {
    return 'ettevottest';
  } else if (path.includes('/partnerile')) {
    return 'partnerile';
  } else {
    return 'other';
  }
};

export const isHtml = RegExp.prototype.test.bind(/(<([^>]+)>)/i);

export const clearWhitespace = (input: string) => input.replace(/\s/g, '');

export const toCamelCase = (snakeCaseString: string) => snakeCaseString.split('_').reduce((a, b) => a + b[0].toUpperCase() + b.slice(1));

export const capitalize = (s: string) => {
  if (!s || typeof s !== 'string') {
    return '';
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getServiceInfo = (serviceInfo: DisturbanceInfoText[], currentLanguage: Language) => {
  serviceInfo = serviceInfo || [];

  const getLang = (targetLang: string) => {
    return serviceInfo.filter((info) => info.languageCode === targetLang);
  };

  let serviceInfoText = '';
  if (serviceInfo.length) {
    const languages = [currentLanguage.toString()].concat(ALLOWED_LANGUAGES);
    for (const language of languages) {
      const serviceInfoTextResult = getLang(language);
      if (serviceInfoTextResult.length) {
        serviceInfoText = serviceInfoTextResult[0].infoText;
        break;
      }
    }
  }
  return serviceInfoText;
};
